import React, { useEffect, useState } from 'react';
import { CenterMissingPayment, PagingResult } from 'models';
import { Text } from 'library';
import { useClient } from 'shared';
import { TimesheetsTable } from './TimesheetsTable';

export function CenterMissingPaymentReports({
    locationId,
    small,
    timesheetRefresh,
}: {
    locationId?: string | number;
    small: boolean;
    timesheetRefresh: () => void;
}) {
    const [page, setPage] = useState(1);
    const {
        send: fetchMissingPayments,
        data: missingPayments,
        loading,
    } = useClient<PagingResult<CenterMissingPayment>>({
        url: `api/center-missing-payment/?location=${locationId}&page=${page}`,
        options: { sendImmediately: false },
    });

    useEffect(() => {
        fetchMissingPayments();
    }, [locationId, page]);

    if (!missingPayments?.results?.length) return null;

    return (
        <div>
            <Text variant="h2" bold>
                Missing Payments Reported ({missingPayments?.results?.length})
            </Text>
            <Text variant="body2" textStyle={{ paddingBottom: 10, marginTop: 5 }}>
                These workers have reported that they were missing payment for a shift at this center.{' '}
                <b>We do not have timesheets for these shifts, and all times were entered manually by the worker.</b>{' '}
                Please approve or deny all reports below.
            </Text>
            <TimesheetsTable
                data={missingPayments}
                small={small}
                loading={loading}
                refresh={() => {
                    fetchMissingPayments();
                    timesheetRefresh();
                }}
                page={page}
                setPage={setPage}
            />
        </div>
    );
}
